import React from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import Ecommerce from "../../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../../images/services/cto/RealEstate.svg";
import Education from "../../../images/services/cto/Education.svg";
import Healthcare from "../../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../../images/services/cto/lifestyle.svg";
import Music from "../../../images/services/cto/Music-01.svg";

import { LazyLoadImage } from "react-lazy-load-image-component";

function Techsolution(props) {
  return (
    <div className="p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={8} xl={7} xxl={7}>
            <div className="example" data-text="ERP Solutions">
              <h2>ERP Solutions For Diverse Industries</h2>
            </div>
          </Col>
        </Row>
        <Row className="tech_bg">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tech_tabs">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <LazyLoadImage
                    src={Healthcare}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Healthcare
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    ERP software development for hospitals and medical
                    facilities is essential due to their diverse staff and the
                    wide range of operations they perform. These operations span
                    from primary medical care to managing patient billing and
                    insurance.
                  </p>
                  <p>
                    We as an ERP development company, specializ in building
                    powerful ERP systems customized for healthcare organizations
                    to help streamline operations and automate internal and
                    external management reporting and accountability.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <LazyLoadImage
                    src={RealEstate}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Real Estate
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    As an ERP system development company, we help brokers,
                    realtors, property entrepreneurs, and real estate firms
                    build and deploy ERP solutions to manage transactions,
                    optimize deals and contracts, analyze leads and conversions,
                    check lease installments, and monitor mortgage payments.
                  </p>
                  <p>
                    A custom-built ERP as software can help streamline internal
                    and external processes and transform the property management
                    experience for all stakeholders.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <LazyLoadImage
                    src={Ecommerce}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Ecommerce
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    The ecommerce industry is one of the first movers to ERP
                    and, since then, has witnessed transformative business cases
                    of deploying such a SaaS.
                  </p>
                  <p>
                    A company ERP system serves as the backbone of ecommerce
                    store operations, consolidating various functions such as
                    finance, supply chain management, and customer relationship
                    management into a single integrated platform.
                  </p>
                  <p>
                    It helps eCommerce and retail companies manage their
                    internal and external processes by offering omnichannel
                    payment integration and real-time dashboards for analytics.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <LazyLoadImage
                    src={Education}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Education
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    EdTech has been getting increasingly popular ever since
                    remote learning became famous. It offers benefits that
                    physical learning does not, which is why institutes and
                    students are opting for e-learning solutions in many parts
                    of the world.
                  </p>
                  <p>
                    As an ERP software development company, we incorporate
                    modern practices to build high-coverage, end-to-end learning
                    management systems guaranteeing a brighter future. These ERP
                    systems are built using modern technology to meet the
                    objectives of effective learning, modern teaching, and
                    managing hardware and software.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <LazyLoadImage
                    src={Music}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Music
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    We assist music entrepreneurs in developing and implementing
                    a strong ERP system customized to meet their specific needs
                    in music production, content publishing, and personalized
                    content distribution. By utilizing advanced technologies
                    such as AI and ML, our solutions empower music companies to
                    optimize their internal processes, streamline content
                    creation and distribution workflows, and increase customer
                    engagement through personalized recommendations.
                  </p>
                  <p>
                    With robust databases and powerful backend systems, our ERP
                    software allows music businesses to achieve significant
                    automation of key business processes.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <LazyLoadImage
                    src={Lifestyle}
                    effect="blur"
                    alt="Healthcare"
                    className="img-fluid"
                  />
                  Lifestyle
                </Accordion.Header>
                <Accordion.Body>
                  <p>
                    The lifestyle industry has seen some of the most successful
                    implementations of ERP systems. From startups to large-scale
                    production brands, a custom-built ERP system can streamline
                    manufacturing through distribution and supply chain
                    processes.
                  </p>
                  <p>
                    It provides real-time analytics on costs, sales, and
                    marketing, updates inventory batches, and analyzes current
                    and future product demands allowing businesses to make
                    informed decisions and adapt quickly to market changes.
                  </p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
